import { ICloudpaymentsStartWidgetPaymentResponse } from '../../../../repositories/billing-accounts/v1/cloudpayments/start-widget-payment';
import { IGetBaseCloudPaymentsWidgetParamsResult } from '../types';
import { mapWidgetOptions } from './mapWidgetOptions';
import { mapPaymentOptions } from './mapPaymentOptions';

interface IParams {
  amount: number;
}

export const mapResponse200 =
  (params: IParams) =>
  (response: ICloudpaymentsStartWidgetPaymentResponse): IGetBaseCloudPaymentsWidgetParamsResult => {
    const { amount } = params;

    return {
      widgetOptions: mapWidgetOptions(response),
      paymentOptions: mapPaymentOptions({ response, amount }),
    };
  };
